import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form }                     from "semantic-ui-react";
import ChangeStaffPassword          from "../../../application/usecase/staff/ChangeStaffPassword";
import FirstName                    from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana                from "../../../domain/fundamentals/name/FirstNameKana";
import LastName                     from "../../../domain/fundamentals/name/LastName";
import LastNameKana                 from "../../../domain/fundamentals/name/LastNameKana";
import Staff                        from "../../../domain/staff/Staff";
import StaffRepository              from "../../../domain/staff/StaffRepository";
import { ResKaState }               from "../../../index";
import StaffDataSource              from "../../../infrastructure/datasource/staff/StaffDataSource";
import GenderSelector               from "../common/GenderSelector";
import PasswordChangeButton         from "../common/PasswordChangeButton";
import ValidatorMessage             from "../message/ValidatorMessage";

const StaffAccountEditForm: FC = () => {
  const staff: Staff = useSelector((state: ResKaState) => state.staff);
  const repository: StaffRepository = new StaffDataSource(useDispatch());
  const changeStaffPassword: ChangeStaffPassword = new ChangeStaffPassword(useDispatch());

  return (
    <>
      <Form>
        <Form.Group>
          <Form.Field required>
            <label>氏名(姓)</label>
            <Form.Input
              value={ staff.name.lastName.value }
              onChange={ (event, data) => repository.setLastName(new LastName(data.value)) }
            />
            <ValidatorMessage target="last_name"/>
          </Form.Field>
          <Form.Field required>
            <label>氏名(名)</label>
            <Form.Input
              value={ staff.name.firstName.value }
              onChange={ (event, data) => repository.setFirstName(new FirstName(data.value)) }
            />
            <ValidatorMessage target="first_name"/>
          </Form.Field>
        </Form.Group>

        <Form.Group>
          <Form.Field required>
            <label>氏名カナ(姓)</label>
            <Form.Input
              value={ staff.name.lastNameKana.value }
              onChange={ (event, data) => repository.setLastNameKana(new LastNameKana(data.value)) }
            />
            <ValidatorMessage target="last_name_kana"/>
          </Form.Field>
          <Form.Field required>
            <label>氏名カナ(名)</label>
            <Form.Input
              value={ staff.name.firstNameKana.value }
              onChange={ (event, data) => repository.setFirstNameKana(new FirstNameKana(data.value)) }
            />
            <ValidatorMessage target="first_name_kana"/>
          </Form.Field>
        </Form.Group>

        <Form.Group>
          <GenderSelector
            genderType={ staff.genderType }
            onChange={ genderType => repository.setGenderType(genderType) }
          />
        </Form.Group>

        <Form.Group>
          <Form.Field>
            <label>ログインID</label>
            <label>{ staff.loginId.value }</label>
          </Form.Field>
        </Form.Group>

        <Form.Group>
          <Form.Field>
            <PasswordChangeButton
              onClick={ (currentPassword, newPassword, confirmPassword, callback) => changeStaffPassword.execute(staff.id, currentPassword, newPassword, confirmPassword, callback) }
            />
          </Form.Field>
        </Form.Group>
      </Form>
    </>
  );
};

export default StaffAccountEditForm;
